import { AnimatePresence, motion } from 'motion/react';
import { BaleCreateContextProvider, BaleCreatePageType } from './context';
import { BaleCreateErrorHandler } from './error-handler';
import { useBaleCreateContext } from './hook';
import { BaleCreateAddPhotoPage } from './subroutes/add-photo';
import { BaleCreateConfirmPage } from './subroutes/confirm-create';
import { BaleCreateManualCodeEntryPage } from './subroutes/manual-code-entry';
import { BaleCreateMaterialConfirmPage } from './subroutes/material-confirm';
import { BaleCreateScanPage } from './subroutes/scan';
import { BaleCreateSuccessPage } from './subroutes/success';

export const BaleCreatePage = () => {
	return (
		<BaleCreateContextProvider>
			<BaleCreatePageRoot />
		</BaleCreateContextProvider>
	);
};

const BaleCreatePageRoot = () => {
	return (
		<AnimatePresence>
			<SubRoute key="SCAN" id="SCAN" component={<BaleCreateScanPage />} />
			<SubRoute key="MANUAL" id="MANUAL" component={<BaleCreateManualCodeEntryPage />} />
			<SubRoute key="IDENTIFY" id="IDENTIFY" component={<BaleCreateMaterialConfirmPage />} />
			<SubRoute key="PHOTO" id="PHOTO" component={<BaleCreateAddPhotoPage />} />
			<SubRoute id="CONFIRM" component={<BaleCreateConfirmPage />} />
			<SubRoute id="SUCCESS" component={<BaleCreateSuccessPage />} />
			<BaleCreateErrorHandler />
		</AnimatePresence>
	);
};

const SubRoute = ({ id, component }: { id: BaleCreatePageType; component: React.ReactNode }) => {
	const { page } = useBaleCreateContext();

	if (page !== id) return null;

	return (
		<motion.div
			key={id}
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.3 }}
		>
			{component}
		</motion.div>
	);
};
